module.exports = __webpack_public_path__ + "static/media/smoworks.1f450da1.png";